export enum NotificationBarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  NORMAL = 'normal',
  DEFAULT = 'default',
}
